import React from "react";
import IwButton from "../../app/IwButton";
import { Box, Button, Stack, useTheme } from "@mui/material";
import PublishOutlinedIcon from "@mui/icons-material/PublishOutlined";
import { baseAtom, setViewTemplatesOpen } from "../../../stores/jotai/base";
import { FileCopy } from "@mui/icons-material";
import { useAtom } from "jotai";

interface InterviewPublishAndTemplateProps {
  isPublishing: boolean;
  publishInterview: () => void;
}

const InterviewPublishAndTemplate: React.FC<
  InterviewPublishAndTemplateProps
> = (props) => {
  const { publishInterview, isPublishing } = props;
  const [base, setBase] = useAtom(baseAtom);
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent:"flex-end",
        gap: 1,
      }}
    >
      <Stack
        direction="row"
        spacing={1}
        sx={{  boxShadow: "none" }}
      >
        <Button
          id="joy-discovery-templates"
          sx={{
            whiteSpace: "nowrap",
            flexGrow: 1,
            color: theme.custom.mainIconColor,
            borderColor: theme.custom.borderGrey,
            ":hover": {
              color: theme.custom.mainButtonHighlight,
            },
            padding: "18px",
          }}
          variant="outlined"
          onClick={() => {
            setViewTemplatesOpen(setBase, true);
          }}
          startIcon={<FileCopy color="primary" />}
        >
          View Templates
        </Button>
      </Stack>

      <IwButton
        variant="outlined"
        startIcon={<PublishOutlinedIcon />}
        loading={isPublishing}
        sx={{
          "& .MuiButton-startIcon": {
            marginRight: "4px",
          },
          // minWidth: "90px",
          padding: "7px 24px 6px 24px",
          // margin: "0px 6px",
          ".MuiCircularProgress-svg": {
            color: theme.custom.gray60,
          },
          border: `1px solid ${theme.custom.borderGrey}`,
          background: "white",
          color: theme.custom.gray60,
          ":hover": {
            color: theme.custom.mainButtonHighlight,
            border: `1px solid ${theme.custom.mainButtonHighlight}`,
            background: "white",
          },
          height: "100%",
        }}
        onClick={publishInterview}
      >
        Publish
      </IwButton>
    </Box>
  );
};
export default InterviewPublishAndTemplate;
